module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGMAAABjBAMAAAB9FaOmAAAAJFBMVEX///8AQMDX4vY8bc+wxOtnjdlCcdD8/f8MScOIpuKRreRqj9ofz24NAAAAz0lEQVR4Ae2X5YHCQBBGd+/wX/twqAI6gg6SDqAjqBB3nR0c5ovLi4wmzvQ1IlbhdxFDDPk4+acg8Zb5oxyLeIhFutCJROLd7AnwcATmVAyRoeayVMXGPdRVRpEffQ7Uk9hq/eYwnyTBVXEpg/nqkOSfssy+sL6hzNKeFm03V4kWSM0cttaTRmSyXEulsTmG7Q1H0pDcMYXiLop30VhM7Re99/Uxpo9kfb5wqKDPfX2F0dex5xdYdeXX9BcPT+iVjvD8TwX75THEkG9DvkWmKSC7hnHgLDc9AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/uis/assets/images/flags/Israel.png
// module id = 582
// module chunks = 0